<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Acreedor
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="investor_details" v-if="loaded"/>
        <!--end: Details -->
        <hr class="mt-4"/>
        <!--begin: Fiscal Info -->
          <div class="row mt-4">
              <div class="col-sm col-md col-lg">
                  <h4 class="m--font-info">Datos fiscales</h4>
              </div>
          </div>
          <sys-form :inputs="investor_fiscal"/>
        <!--end: Fiscal Info -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'investors' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import investorsService from '@/services/investors'
import promotersService from '@/services/promoters'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'InvestorCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      investor_details: {
        promoter_id: {
          name: 'Promotor',
          value: '',
          type: 'select',
          size: 12,
          validate: 'required'
        },
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido Paterno',
          hint: 'Apellido Paterno',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido Materno',
          hint: 'Apellido Materno',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        type: {
          name: 'Tipo',
          value: '',
          type: 'select',
          options: [
            { value: 'Fisica', text: 'Física', selected: true },
            { value: 'Moral', text: 'Moral' }
          ],
          size: 3,
          validate: 'required'
        },
        email: {
          name: 'Correo',
          hint: 'Correo',
          value: '',
          type: 'email',
          size: 8
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text'
        },
        curp: {
          name: 'CURP',
          hint: 'CURP',
          value: '',
          type: 'text'
        },
        nationality: {
          name: 'Nacionalidad',
          hint: 'Nacionalidad',
          value: '',
          type: 'text'
        },
        dob: {
          name: 'Fecha de Nacimiento',
          value: '',
          type: 'date'
        },
        description: {
          name: 'Descripción',
          hint: 'Observaciones',
          value: '',
          type: 'textarea',
          size: 12
        }
      },
      investor_fiscal: {
        rfc: {
          name: 'RFC',
          hint: 'RFC',
          value: '',
          type: 'text',
          validate: 'required'
        },
        street: {
          name: 'Calle',
          hint: 'Calle',
          value: '',
          type: 'text'
        },
        number: {
          name: 'Número ext./int.',
          hint: 'Número ext./int.',
          value: '',
          type: 'number',
          min: 0,
          max: 9999,
          size: 2
        },
        zip: {
          name: 'Código postal',
          hint: 'Código postal',
          value: '',
          type: 'number',
          min: 0,
          max: 99999,
          size: 2
        },
        neighborhood: {
          name: 'Colonia',
          hint: 'Colonia',
          value: '',
          type: 'text'
        },
        city: {
          name: 'Municipio',
          hint: 'Municipio',
          value: '',
          type: 'text'
        },
        state: {
          name: 'Estado',
          hint: 'Estado',
          value: '',
          type: 'text'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    promotersService.list({}).then(res => {
      this.investor_details.promoter_id.options = res.data.map(promoter => {
        return { value: promoter.id, text: promoter.fullname }
      })
      this.loaded = true
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.investor_details)

          let fiscalData = this.processForm(this.investor_fiscal)
          if (Object.keys(fiscalData).length) body['fiscal_data'] = fiscalData

          let service = investorsService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'investors', props: { investor: res } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },
  watch: {
    'investor_details.type.value': function (type, oldType) {
      if (type.value === 'Moral') {
        this.investor_details['corporate_name'] = {
          name: 'Razón Social',
          hint: 'Razón Social',
          value: '',
          type: 'text'
        }
      } else if (type.value === 'Fisica') {
        delete this.investor_details['corporate_name']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/investors/InvestorCreate.vue